import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — straight stair flight. Occupies 1x2 tiles and climbs one
// storey (2.6 m) along +Z: the first step rises at z = -1, the top step
// reaches y = 2.6 at z = +1. Eight solid full-height steps read as one
// chunky flight; landings are ordinary floor tiles.
const OAK = "#c8975a";
const OAK_DARK = "#b3814a";

const STEPS = 8;
const RISE = 2.6 / STEPS; // 0.325 per step
const TREAD = 2.0 / STEPS; // 0.25 per step

export const stairsStraight = defineModel({
  id: "stairs-straight",
  batchId: "modern",
  name: "Straight stairs",
  tags: ["modern", "interior", "structure", "stairs"],
  summary: "A straight oak stair flight climbing one storey over 1x2 tiles.",
  description:
    "The straight stair of the Modern Living kit: 1x2 tiles, climbing one " +
    "storey (2.6 m) along +Z in eight chunky steps. Place a floor tile at " +
    "the top as the landing.",
  tiles: { w: 1, h: 2 },
  footprint: 1.6,
  parts(): Part[] {
    const steps: Part[] = [];
    for (let i = 0; i < STEPS; i++) {
      const top = (i + 1) * RISE;
      steps.push({
        geometry: new THREE.BoxGeometry(1.0, top, TREAD),
        color: i % 2 === 0 ? OAK : OAK_DARK,
        position: [0, top / 2, -1 + TREAD / 2 + i * TREAD],
      });
    }
    return steps;
  },
  animations: [],
});
